module.exports = __webpack_public_path__ + "static/media/floor_tom_2.5f5ffed8.png";